import * as apiGetSettingKey from 'api/userSetting/GetUserSettingKeyV1';
import { ValueScope } from 'enums/valueScope';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';

export async function getvalueScope(): Promise<ValueScope> {
	const response = await apiGetSettingKey.callApi('Recipe.List.ValueScope');

	return response
		.map((x) => ValueScope[x as keyof typeof ValueScope])
		.getOrDefault(ValueScope.Person);
}

const rb = new ReducerBuilder<ValueScope>();
export const valueScopeLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'valueScope/LoadedFromBackend'
);

export const setReduxValueScope = rb.createActionForReducer(
	payloadReducer((x) => x),
	'valueScope/SET'
);

export const valueScopeReducer = rb.createReducer();
